import React, { FC } from 'react';
import { Space } from 'antd';

import styled, { css } from 'styled-components';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { Checkbox } from '~/components';
import colors from '~/constants/colors';
import theme from '~/constants/theme';
import { DirectionProp } from '~/types/Direction';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';
import { useServicesContext } from '~/controllers/ServicesContext';
import { capitalizeWords } from '~/utils/validateCharacters';

interface Props {
  inputKey?: string;
  disabled?: boolean;
  name: string;
  header?: string;
  value?: string;
}

const HierarchyCheckBox: FC<Props> = (props) => {
  const { inputKey, name, header, disabled, value } = props;

  const dir = useDirection();
  const servicesContext = useServicesContext();

  return (
    <Checkbox
      value={value}
      id={`service_checkbox_${inputKey}`}
      className="ServiceCheckbox-Checkbox"
      disabled={disabled}
    >
      {capitalizeWords(name)}
    </Checkbox>
  );
};

const Container = styled.div<DirectionProp>`
  flex-direction: row-reverse;
  padding-top: 12px;

  .ServiceCheckbox-Checkbox {
    display: flex;
    flex-direction: row;
    /* background-color: green; */
    padding: 10px 0 10px 0;

    ${({ dir }) =>
      dir === 'rtl'
        ? css`
            justify-content: center;
          `
        : css`
            justify-content: center;
          `}
    .ServiceCheckbox-ServiceName {
      color: ${colors.primaryColor};
      white-space: nowrap;
    }

    span:not(.ant-checkbox) {
      padding-left: 0;
    }
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    padding-top: 0;
    border-bottom: unset;
    .ServiceCheckbox-Checkbox {
      margin-bottom: 0;
      margin-left: 0;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      .ant-checkbox {
        top: 0;
        .ant-checkbox-inner,
        input {
          width: 24px;
          height: 24px;
          border-radius: 4px;
        }
        .ant-checkbox-inner::after {
          left: calc(50% - 5px);
        }
      }
      span:not(.ant-checkbox) {
        flex: 1;
        padding-left: 0;
      }
    }
  }
`;

export default HierarchyCheckBox;
